type ResourceSource = {
    name: string;
    type: string;
    path: string | string[];
};

const sources: ResourceSource[] = [
    {
        name: "test",
        type: "test",
        path: [
            "textures/environmentMap/px.jpg",
            "textures/environmentMap/nx.jpg",
            "textures/environmentMap/py.jpg",
            "textures/environmentMap/ny.jpg",
            "textures/environmentMap/pz.jpg",
            "textures/environmentMap/nz.jpg",
        ],
    },
];

export default sources;
